import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useFetch, usePromise } from '@rad/hooks';
import { getScorecard } from '../types';
import LayoutRoot from '../layouts/root';
import AuditTable from '../components/tables/audit';
const ScorecardMeasuresLog = (props) => {
    const [scorecardPromise] = useFetch(getScorecard(props.id));
    const scorecard = usePromise(scorecardPromise);
    return scorecard && scorecard.measures.map((x) => _jsx(AuditTable, { kind: 'scorecard-measure', id: x.id, title: `Measure: ${x.title} (${x.measure.display})` }, x.id));
};
export const AuditLogScreen = (props) => {
    return _jsxs(LayoutRoot, { children: [_jsx(AuditTable, { kind: props.kind, id: props.id }), props.kind === 'scorecard' && _jsx(ScorecardMeasuresLog, { id: props.id })] });
};
export default AuditLogScreen;
